<script setup>
import { ref, defineEmits, onMounted, watch } from "vue";
import csvIcon from "@/assets/csvIcon.svg";
import CreatingFont from "@/components/Lists/Schemes/CreatingFont.vue";
import Papa from "papaparse";
/* import CardFontList from "@/components/common/CardFontList.vue"; */
import { EyeIcon, EyeSlashIcon } from "@heroicons/vue/24/solid";
import CardFontS3 from "@/components/common/CardFontS3.vue";
/* import { getProjects } from "@/services/projects";
import { getProjectChannels } from "@/services/channels";
import { getCategoryMessage } from "@/services/categoryMessage";
import { postList, createList } from "@/services/lists"; */

const fontName = ref("");
const fontDescription = ref("");

const file = ref(null);
const title = ref(false);
const filename = ref("");
const delimiter = ref("");

let csvData = ref([]);

let columnTitles = ref([]);
const showSecondSection = ref(false);

const clientID = ref("");
const clientSecret = ref("");
const isClientSecretVisible = ref(false);
const domain = ref("");

const toggleSecretKeyVisibility = () => {
  isClientSecretVisible.value = !isClientSecretVisible.value;
};
const showNotification = ref(false);

const nameConnection = ref("");
const fontCategory = ref("");
const sendDate = ref("");

const showThirdSection = ref(false);
const creatingFontVisible = ref(false);

const columnPreviews = ref({});
const selectedColumn = ref(null);
const selectedColumnData = ref({});
const encryptionStates = ref({});

const selectedAttributes = ref(null);
const selectedNameAttributes = ref(null);

const projects = ref([]);
const selectedProjectId = ref(null);
const channels = ref([]);
const messages = ref([]);

const selectedChannelId = ref(null);
const selectedMessageId = ref(null);

const listDetails = ref({ key: null, bucket: null });

onMounted(async () => {
  const clientId = localStorage.getItem("cx");
  console.log("Client ID:", clientId);
  if (!clientId) {
    console.error("Client ID not found in localStorage");
    return;
  }
  try {
    const response = await getProjects(clientId);
    console.log("Fetched Projects:", response.data);
    if (response.data.length) {
      projects.value = response.data;
    }
    console.log("PROYECTS:", projects.value);
  } catch (error) {
    console.error("Error fetching rules:", error);
  }
});

// actualizar canales y mensajes cuando se selecciona un proyecto
watch(selectedProjectId, async (newProjectId) => {
  console.log("Proyecto seleccionado:", newProjectId);
  if (newProjectId) {
    try {
      const response = await getProjectChannels(newProjectId);
      console.log("Canales obtenidos:", response.data);
      channels.value = response.data;

      const messagesResponse = await getCategoryMessage(newProjectId);
      console.log("Mensajes obtenidos:", messagesResponse.data);
      messages.value = messagesResponse.data;
    } catch (error) {
      console.error("Error al obtener los canales:", error);
    }
  } else {
    channels.value = [];
    messages.value = [];
  }
});

// Subir y procesar csv
const handleFileChange = (event) => {
  file.value = event.target.files[0];
  updateFilename();
  handleSuccess(file);
};

const updateFilename = () => {
  if (file.value) {
    filename.value = file.value.name;
  }
};
// Procesar archivo CSV
const handleSuccess = (file) => {
  if (file) {
    console.log("Archivo subido exitosamente", file);
    Papa.parse(file.value, {
      header: title.value,
      skipEmptyLines: true,
      delimiter: delimiter.value === "" ? "," : delimiter,
      complete: (results) => {
        console.log("CSV data:", results.data);
        csvData.value = results.data;

        if (!title.value) {
          // Extraer la primera fila como títulos
          const firstRow = results.data[0];
          columnTitles.value = Object.keys(firstRow).map(
            (key) => firstRow[key]
          );

          // Convertir el resto de las filas en objetos usando los nuevos títulos
          csvData.value = results.data.slice(1).map((row) => {
            let obj = {};
            columnTitles.value.forEach((title, index) => {
              obj[title] = row[Object.keys(row)[index]];
            });
            return obj;
          });
        } else {
          columnTitles.value = results.meta.fields || [];
        }

        // Asignar directamente a columnPreviews.value
        columnPreviews.value = {};
        columnTitles.value.forEach((title) => {
          columnPreviews.value[title] = csvData.value
            .slice(0, 3)
            .map((row) => row[title]);
        });

        console.log("Column Previews:", columnPreviews.value);
      },
      error: (error) => {
        console.log("Error al procesar el archivo CSV:", error);
      },
    });
  } else {
    console.log("Error al subir el archivo");
  }
};
//----
let currentId = 0;
let isSubmitting = false;

/* const submitForm = () => {
  if (isSubmitting) {
    console.log("Ya se está procesando una solicitud.");
    return; // evitar envío doble
  }
  isSubmitting = true;
  try {
    const clientName = localStorage.getItem("clientName");
    if (!clientName) {
      console.error("No se encontró 'clientName' en localStorage");
      isSubmitting = false;
      return;
    }

    currentId += 1;

    // payload
    const formData = new FormData();
    formData.append("id", currentId.toString());
    formData.append("file", file.value);
    formData.append("client", clientName);

    // imprimir contenido de formData
    for (let pair of formData.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    // Llamar a postList
    postList(formData)
      .then((postResponse) => {
          console.log("Respuesta de postList:", postResponse.data);

        const key = postResponse.data.key;
        const bucket = postResponse.data.bucket;

        if (!key || !bucket) {
          throw new Error(
            "La respuesta de postList no contiene 'key' o 'bucket'"
          );
        }

        // extraer key y bucket
        listDetails.value.key = key;
        listDetails.value.bucket = bucket;

        showSecondSection.value = true;
      })
      .catch((error) => {
        console.error("Error al manejar la fuente:", error);
      })
      .finally(() => {
        isSubmitting = false;
      });
  } catch (error) {
    console.error("Error al manejar la fuente:", error);
    isSubmitting = false;
  }
}; */
const submitForm = () => {
  console.log("Iniciando submitForm");
  console.log("Campos completos:", areFieldsComplete());
  if (!areFieldsComplete()) {
    console.log("Campos incompletos, no se puede avanzar.");
    return;
  }
  showSecondSection.value = true;
  console.log("showSecondSection actualizado:", showSecondSection.value);
  // ...
};

onMounted(() => {
  scrollToSecondSection();
});

const submitSecondForm = () => {
  console.log("Submit del segundo formulario");
  console.log("showThirdSection:", showThirdSection.value);
  if (clientID.value && !showThirdSection.value) {
    showNotification.value = true;
    setTimeout(() => {
      showNotification.value = false;
      showThirdSection.value = true;
    }, 2000);
    /* showThirdSection.value = true; */
  } else if (clientID.value && showThirdSection.value) {
    console.log("clientID:", clientID.value);
    console.log("Client Secret:", clientSecret.value);
    console.log("Domain:", domain.value);
  }
};

const submitThirdForm = () => {
  if (
    nameConnection.value &&
    showThirdSection.value &&
    selectedColumnData.value.length > 0
  ) {
    console.log("Selected column data:");
  }
};

const emits = defineEmits(["closeModal"]);

const resetAndCloseModal = () => {
  reset();
  emits("closeModal");
};

const reset = () => {
  fontName.value = "";

  clientID.value = "";
  clientSecret.value = "";
  domain.value = "";

  file.value = null;
  title.value = false;
  filename.value = "";
  delimiter.value = "";
  nameConnection.value = "";
  fontDescription.value = "";
  fontCategory.value = "";
  sendDate.value = "";
  showSecondSection.value = false;
};

// Verificar campos step 1
const areFieldsComplete = () => {
  return !!fontName.value && !!fontDescription.value;
};
console.log("corroborando:", areFieldsComplete());
// Verificar campos step 2
const areFieldsCompleteSecond = () => {
  return !!clientID.value && !!clientSecret.value && !!domain.value;
};
console.log("corroborando step2:", areFieldsCompleteSecond());

const scrollToSecondSection = () => {
  setTimeout(() => {
    const secondSection = document.getElementById("secondSection");
    if (secondSection) {
      window.scrollTo({
        top: secondSection.offsetTop,
        behavior: "smooth",
      });
    }
  }, 200);
};

watch(showSecondSection, (newValue) => {
  if (newValue) {
    scrollToSecondSection();
  }
});

const scrollToThirdSection = () => {
  setTimeout(() => {
    const thirdSection = document.getElementById("thirdSection");
    if (thirdSection) {
      window.scrollTo({
        top: thirdSection.offsetTop,
        behavior: "smooth",
      });
    }
  }, 200);
};

watch(showThirdSection, (newValue) => {
  if (newValue) {
    scrollToThirdSection();
  }
});

watch(title, (newValue) => {
  console.log("El valor de title ha cambiado a:", newValue);
});

const isDropdownOpen = ref(false);

/* Click fuera del dropdown */
onMounted(() => {
  document.addEventListener("click", (event) => {
    if (!event.target.closest(".dropdown")) {
      isDropdownOpen.value = false;
    }
  });
});

function handleEncryptionUpdate({ attribute, isEncrypted }) {
  encryptionStates.value[attribute] = isEncrypted;
  if (selectedColumnData.value[attribute]) {
    selectedColumnData.value[attribute].isEncrypted = isEncrypted;
  }
}
const handleSelectAttribute = (selectedTitle) => {
  selectedColumn.value = selectedTitle;
  selectedNameAttributes.value = selectedTitle;
  selectedAttributes.value = columnTitles.value.indexOf(selectedTitle);

  // Guardar solo la última columna seleccionada
  selectedColumnData.value = {
    [selectedTitle]: {
      data: csvData.value.map((row) => row[selectedTitle]),
      isEncrypted: encryptionStates.value[selectedTitle] || false,
    },
  };

  console.log("Índice de columna seleccionada:", selectedAttributes.value);
  console.log("Nombre de columna seleccionada:", selectedNameAttributes.value);
};

const createFont = () => {
  console.log("createFont llamado");
  if (
    areFieldsComplete() &&
    areFieldsCompleteSecond() &&
    selectedAttributes.value !== null &&
    selectedNameAttributes.value
  ) {
    if (!listDetails.value.key || !listDetails.value.bucket) {
      console.error("No se encontró 'key' o 'bucket' en listDetails");
      return;
    }

    const fontData = {
      fontName: fontName.value,
      key: listDetails.value.key,
      bucket: listDetails.value.bucket,
      isHash: selectedColumnData.value[selectedColumn.value]?.isEncrypted,
      hasHeader: title.value,
      delimiter: delimiter.value,
      nameConnection: nameConnection.value,
      fontDescription: fontDescription.value,
      fontCategory: fontCategory.value,
      sendDate: sendDate.value,
      selectedAttributes: selectedAttributes.value,
      selectedNameAttributes: selectedNameAttributes.value,
      projectsId: selectedProjectId.value,
      channelsId: selectedChannelId.value,
      categoryMessageId: selectedMessageId.value,
    };

    console.log("Información de la fuente:", fontData);

    createList(fontData)
      .then((response) => {
        console.log("Fuente creada exitosamente:", response.data);
      })
      .catch((error) => {
        console.error("Error al crear la fuente:", error);
      });

    creatingFontVisible.value = true;
  } else {
    console.log(
      "Todos los campos deben estar completos y se debe seleccionar una columna antes de crear la fuente."
    );
  }
};
</script>

<template>
  <div style="background: white">
    <article>
      <h5 class="create-title mt-1 mb-4">
        Listas / Selecciona la plataforma / Marketing Cloud Data Extension
      </h5>
      <section>
        <div>
          <div class="d-flex gap-2 align-items-center m-0">
            <p class="circle pt-1">1</p>
            <p style="margin: 0; font-weight: 600; color: #243949">
              Completa los datos de tu fuente
            </p>
          </div>
        </div>
        <!-- *Primer formulario -->
        <form @submit.prevent="submitForm">
          <div
            style="
              padding-top: 2rem;
              padding-bottom: 2rem;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              gap: 10px;
            "
          >
            <div
              class="font-section py-5"
              style="
                justify-content: start;
                padding-left: 2rem;
                flex-direction: column;
                gap: 1rem;
                height: auto;
              "
            >
              <div class="d-flex flex-column" style="width: 100%">
                <label class="globals-label mb-2" for="delimiter"
                  >Nombre de la Fuente</label
                >
                <input
                  class="form-control globals-input"
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Nombre de la Fuente"
                  v-model="fontName"
                />
              </div>

              <div class="d-flex flex-column" style="width: 100%">
                <label class="globals-label mb-2" for="delimiter"
                  >Descripción</label
                >
                <textarea
                  class="form-control globals-input"
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Descripción de la Fuente"
                  v-model="fontDescription"
                />
              </div>

              <button
                class="globals-button mt-4"
                type="submit"
                @click="submitForm"
                :disabled="!areFieldsComplete()"
                :class="{ 'disabled-button': !areFieldsComplete() }"
              >
                Siguiente
              </button>
            </div>
          </div>
        </form>
      </section>
      <!-- *Second Section -->
      <section id="secondSection" v-if="showSecondSection" class="mt-5">
        <div>
          <div class="d-flex gap-2 align-items-center m-0">
            <p class="circle pt-1">2</p>
            <p style="margin: 0; font-weight: 600; color: #243949">
              Completa los datos de tus credenciales para conectar con Marketing
              Cloud
            </p>
          </div>
        </div>
        <!-- *Segundo formulario -->
        <form @submit.prevent="submitSecondForm">
          <div
            style="
              height: auto;
              padding-top: 2rem;
              padding-bottom: 2rem;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              gap: 10px;
            "
          >
            <div class="font-section" style="height: auto">
              <div class="d-flex flex-column w-100 p-4 gap-4">
                <div class="d-flex flex-column justify-content-center">
                  <label class="globals-label" for=""
                    >Client ID<span class="required">*</span></label
                  >
                  <input
                    v-model="clientID"
                    class="form-control globals-input"
                    type="text"
                    id="clientID"
                    name="clientID"
                    placeholder="Client ID"
                    required
                  />
                </div>
                <div class="d-flex flex-column justify-content-center">
                  <label class="globals-label" for=""
                    >Client Secret<span class="required">*</span></label
                  >
                  <div
                    class="form-control globals-input"
                    style="display: flex; justify-content: space-between"
                  >
                    <input
                      v-model="clientSecret"
                      :type="isClientSecretVisible ? 'text' : 'password'"
                      style="border: none; width: 80%"
                      class="globals-input-no-border no-focus-border"
                      id="ClientSecret"
                      name="ClientSecret"
                      placeholder="Client Secret"
                      required
                    />
                    <button
                      @click="toggleSecretKeyVisibility"
                      style="
                        border: none;
                        width: 10%;
                        background: transparent;
                        display: flex;
                        justify-content: center;
                      "
                      type="button"
                      aria-label="Toggle secret key visibility"
                    >
                      <component
                        :is="isClientSecretVisible ? EyeSlashIcon : EyeIcon"
                        style="width: 25px; height: 25px; color: #517fa4"
                      ></component>
                      <!-- <EyeIcon
                        class="d-flex justify-content-center"
                        style="width: 25px; height: 25px; color: #517fa4"
                      ></EyeIcon> -->
                    </button>
                  </div>
                </div>
                <div class="d-flex flex-column justify-content-center">
                  <label class="globals-label" for=""
                    >Domain<span class="required">*</span></label
                  >
                  <input
                    v-model="domain"
                    class="form-control globals-input"
                    type="text"
                    id="domain"
                    name="domain"
                    placeholder="Domain"
                    required
                  />
                </div>

                <!-- <div class="mb-3 d-flex flex-column gap-2">
                  <label class="globals-label" for=""
                    >Selecciona un Proyecto<span class="required"
                      >*</span
                    ></label
                  >
                  <select
                    id="week"
                    class="form-select form-select-details text-capitalize"
                    v-model="selectedProjectId"
                  >
                    <option
                      value="0"
                      style="font-weight: 400; color: #99bbd6"
                      disabled
                      selected
                    >
                      Selecciona un proyecto
                    </option>
                    <option
                      v-for="project in projects"
                      :key="project.projectsId"
                      :value="project.projectsId"
                    >
                      {{ project.name }}
                    </option>
                  </select>
                </div> -->

                <!-- <div class="mb-3 d-flex flex-column gap-2">
                  <label class="globals-label" for=""
                    >Selecciona un Canal<span class="required">*</span></label
                  >
                  <select
                    id="week"
                    class="form-select form-select-details text-capitalize"
                    v-model="selectedChannelId"
                  >
                    <option
                      value="0"
                      style="font-weight: 400; color: #99bbd6"
                      disabled
                      selected
                    >
                      Selecciona un Canal
                    </option>
                    <option
                      v-for="channel in filteredChannels"
                      :key="channel.channelsId"
                      :value="channel.channelsId"
                    >
                      {{ channel.name }}
                    </option>
                  </select>
                </div> -->

                <div class="d-flex justify-content-center w-100">
                  <button
                    class="globals-button"
                    type="submit"
                    @click="submitSecondForm"
                    :disabled="!areFieldsCompleteSecond()"
                    :class="{ 'disabled-button': !areFieldsCompleteSecond() }"
                  >
                    Conectar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>

      <section
        v-if="showNotification"
        style="display: flex; justify-content: center"
      >
        <div class="notification-bar">
          <h6>¡Conexión exitosa con Marketig Cloud!</h6>
        </div>
      </section>

      <!-- *Third Section -->
      <section id="thirdSection" v-if="showThirdSection" class="mt-5">
        <div>
          <div class="d-flex gap-2 align-items-center m-0">
            <p class="circle pt-1">3</p>
            <p style="margin: 0; font-weight: 600; color: #243949">
              Configuración de la Extensión.
            </p>
          </div>
        </div>
        <!-- *Tercer Formulario -->
        <form @submit.prevent="submitThirdForm">
          <div
            style="
              height: auto;
              padding-top: 2rem;
              padding-bottom: 2rem;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              gap: 10px;
            "
          >
            <div
              class="font-section flex-column"
              style="height: auto; width: 70%; padding-top: 3rem"
            >
              <div style="width: 100%; display: flex; text-align: start">
                <h6
                  style="margin-bottom: 0; padding-left: 5%"
                  class="globals-label"
                >
                  Selecciona el Data Extension:
                </h6>
              </div>

              <div style="display: flex; width: 100%">
                <h6
                  class="globals-label"
                  style="
                    text-align: start;
                    width: 100%;
                    padding-left: 5%;
                    margin: 2rem 0 0 0;
                  "
                >
                  Sube un ejemplo del archivo CSV y selecciona la llave a
                  vincular.
                </h6>
              </div>
              <div style="margin-top: 2rem">
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    align-items: center;
                  "
                >
                  <img
                    :src="csvIcon"
                    alt="CSV icon"
                    style="width: 60px; height: 60px"
                  />
                </div>
                <!-- !Aqui sube archivo CSV -->
                <label
                  for="fileInput"
                  class="file-label d-flex flex-column justify-content-center gap-2"
                >
                  <input
                    id="fileInput"
                    type="file"
                    accept=".csv"
                    @change="handleFileChange"
                    style="display: none"
                  />
                  <div
                    class="d-flex justify-content-center align-items-center"
                    style="height: 2rem"
                  >
                    <span class="font-archive text-truncate">{{
                      filename
                    }}</span>
                  </div>
                  <div
                    class="d-flex flex-column align-items-center justify-content-center gap-1 w-100"
                  >
                    <span class="file-btn">Seleccionar archivo</span>
                    <p class="font-footnote">
                      Solo archivos CSV. El tamaño no debe exceder los 12MB.
                    </p>
                  </div>
                </label>
              </div>

              <div class="card-grid-container" style="margin-top: 2rem">
                <CardFontS3
                  v-for="(column, index) in columnTitles"
                  :key="index"
                  :attribute="column"
                  :selectedColumnData="selectedColumnData[column] || []"
                  :columnPreviews="columnPreviews[column] || []"
                  :selectedColumn="selectedColumn"
                  @selectColumn="handleSelectAttribute"
                  @updateEncryption="handleEncryptionUpdate"
                >
                </CardFontS3>
              </div>
            </div>
          </div>
        </form>
      </section>
      <!-- TODO:Enviar/descartar formulario  -->
      <div class="d-flex gap-5 py-4 justify-content-center">
        <button
          class="globals-border-button"
          style="font-weight: 700"
          type="button"
          @click="resetAndCloseModal()"
        >
          DESCARTAR
        </button>
        <button
          class="globals-button"
          style="font-weight: 700"
          type="submit"
          @click="createFont"
          :disabled="!areFieldsComplete() || !areFieldsCompleteSecond()"
          :class="{
            'disabled-button':
              !areFieldsComplete() || !areFieldsCompleteSecond(),
          }"
        >
          CREAR FUENTE
        </button>
      </div>
    </article>
    <div
      class="modal-background"
      v-if="creatingFontVisible"
      @click.self="creatingFontVisible = false"
    ></div>
    <div class="modal-content" v-if="creatingFontVisible">
      <CreatingFont />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
.notification-bar {
  background-color: $fourth-color;
  color: $secondary-color;
  text-align: center;
  padding: 10px;
  border-radius: 5px;
  margin: 10px 0;
  font-weight: bold;
  width: 80%;
}
.no-focus-border:focus {
  outline: none;
  border: none;
  box-shadow: none;
}
.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $shadow-color;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  display: flex;
  align-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  margin-left: 3.5rem;
  z-index: 100;
  background: $ultra-white-color;
  padding: 50px;
  border-radius: 5px;
  box-shadow: 0 2px 5px $shadow-color;
}
.card-grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
}

.card-grid-item {
  border: 1px solid $fourth-color;
  border-radius: 8px;
  padding: 15px;
  box-sizing: border-box;
}
.input-with-icon {
  padding-right: 40px;
}

.search-icon {
  position: absolute;
  top: -40px;
  transform: translateX(80%);
  pointer-events: none;
}
.required {
  color: $error2-color;
  margin-left: 5px;
}
.circle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: $primary-color;
  color: $white-color;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: bolder;
  margin: 0;
}

.custom-select {
  position: relative;
}

.custom-select select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  cursor: pointer;
}

.arrow-down {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid $black-color;
}
</style>
